import { type FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { SbSharedWordpressArticlesWrapper } from '../SbSharedWordpressArticles/SbSharedWordpressArticlesWrapper.tsx';
import { SbRespInteriorsModule } from './SbRespInteriorsModule.tsx';
import { showInteriorsModule } from '../SbSharedInteriorsModule/interiorsModuleHelpers.ts';

import { type SbRespInteriorsWordpressArticlesWrapper_itemSearch$data } from './__generated__/SbRespInteriorsWordpressArticlesWrapper_itemSearch.graphql.ts';
import { type SbRespInteriorsWordpressArticlesWrapper_viewer$data } from './__generated__/SbRespInteriorsWordpressArticlesWrapper_viewer.graphql.ts';
import { type SbRespInteriorsWordpressArticlesWrapper_user$data } from './__generated__/SbRespInteriorsWordpressArticlesWrapper_user.graphql.ts';

type Props = {
    itemSearch: SbRespInteriorsWordpressArticlesWrapper_itemSearch$data;
    viewer: SbRespInteriorsWordpressArticlesWrapper_viewer$data;
    user: SbRespInteriorsWordpressArticlesWrapper_user$data | null | undefined;
    isClient: boolean;
};

const SbRespInteriorsWordpressArticlesWrapperComponent: FC<Props> = props => {
    const { itemSearch, viewer, user, isClient } = props;
    const editorial = itemSearch.editorial;

    if (showInteriorsModule(itemSearch.interiorPhotos?.photos)) {
        return (
            <SbRespInteriorsModule
                editorial={editorial}
                itemSearch={itemSearch}
                user={user}
                isClient={isClient}
            />
        );
    } else {
        return <SbSharedWordpressArticlesWrapper editorial={editorial} viewer={viewer} />;
    }
};

export const SbRespInteriorsWordpressArticlesWrapper = createFragmentContainer(
    SbRespInteriorsWordpressArticlesWrapperComponent,
    {
        viewer: graphql`
            fragment SbRespInteriorsWordpressArticlesWrapper_viewer on Viewer {
                ...SbSharedWordpressArticlesWrapper_viewer
            }
        `,
        itemSearch: graphql`
            fragment SbRespInteriorsWordpressArticlesWrapper_itemSearch on ItemSearchQueryConnection {
                ...SbRespInteriorsModule_itemSearch
                editorial: editorialArticles(first: 8) {
                    ...SbRespInteriorsModule_editorial
                    ...SbSharedWordpressArticlesWrapper_editorial
                }
                interiorPhotos(template: "tradeProjectPhoto.search", first: $interiorPhotosCount) {
                    photos {
                        serviceId
                    }
                }
            }
        `,
        user: graphql`
            fragment SbRespInteriorsWordpressArticlesWrapper_user on User {
                ...SbRespInteriorsModule_user
            }
        `,
    }
);
